var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "exchange-detail",
    },
    [
      _vm.article
        ? [
            _c("div", { staticClass: "detail-header" }, [
              _c("div", { staticClass: "author-block" }, [
                _c("img", {
                  staticClass: "avatar",
                  attrs: {
                    src: _vm.article.authorAvatar || _vm.defaultAvatar,
                    alt: "avatar",
                  },
                  on: { error: _vm.onAvatarError },
                }),
                _c("div", { staticClass: "author-meta" }, [
                  _c(
                    "div",
                    { staticClass: "author-name" },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.article.authorName || "匿名") + " "
                      ),
                      _vm.article.tagName
                        ? _c(
                            "el-tag",
                            {
                              staticClass: "tag-chip",
                              style: _vm.tagStyle(_vm.article.tagColor),
                              attrs: { size: "mini", effect: "dark" },
                            },
                            [_vm._v(" " + _vm._s(_vm.article.tagName) + " ")]
                          )
                        : _vm._e(),
                      _vm.isDraft
                        ? _c(
                            "el-tag",
                            {
                              staticClass: "tag-chip",
                              attrs: { size: "mini", type: "info" },
                            },
                            [_vm._v(" 尚未發佈 ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "author-date" }, [
                    _vm._v(_vm._s(_vm.formatDate(_vm.article.buildDate))),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "header-actions" },
                [
                  _vm.article.canEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            size: "mini",
                            type: "primary",
                            icon: "el-icon-edit",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("edit", _vm.article)
                            },
                          },
                        },
                        [_vm._v(" 編輯 ")]
                      )
                    : _vm._e(),
                  _vm.article.canEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            size: "mini",
                            type: "danger",
                            icon: "el-icon-delete",
                          },
                          on: { click: _vm.handleDelete },
                        },
                        [_vm._v(" 刪除 ")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", icon: "el-icon-close" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_vm._v("關閉")]
                  ),
                ],
                1
              ),
            ]),
            _c("h1", { staticClass: "detail-title" }, [
              _vm._v(_vm._s(_vm.article.title)),
            ]),
            _vm.coverUrl
              ? _c(
                  "div",
                  { staticClass: "detail-cover" },
                  [
                    _c("el-image", {
                      attrs: {
                        src: _vm.coverUrl,
                        fit: "contain",
                        "preview-src-list": [_vm.coverUrl],
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c("div", {
              staticClass: "detail-content",
              domProps: { innerHTML: _vm._s(_vm.article.content) },
            }),
            _c(
              "div",
              { staticClass: "comment-section" },
              [
                _c("div", { staticClass: "comment-title" }, [
                  _c("i", { staticClass: "el-icon-chat-dot-round" }),
                  _vm._v(" 留言 (" + _vm._s(_vm.comments.length) + ") "),
                ]),
                _c(
                  "div",
                  { staticClass: "comment-input" },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 3,
                        maxlength: "1000",
                        "show-word-limit": "",
                        placeholder: "我要留言...",
                      },
                      model: {
                        value: _vm.newComment,
                        callback: function ($$v) {
                          _vm.newComment = $$v
                        },
                        expression: "newComment",
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "comment-input-actions" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "primary",
                              loading: _vm.commentSubmitting,
                            },
                            on: { click: _vm.submitComment },
                          },
                          [_vm._v(" 送出留言 ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.comments.length === 0
                  ? _c("div", { staticClass: "comment-empty" }, [
                      _vm._v("目前尚無留言，快來搶頭香吧。"),
                    ])
                  : _vm._e(),
                _vm._l(_vm.comments, function (c) {
                  return _c("div", { key: c.id, staticClass: "comment-item" }, [
                    _c("img", {
                      staticClass: "avatar avatar-sm",
                      attrs: {
                        src: c.commenterAvatar || _vm.defaultAvatar,
                        alt: "avatar",
                      },
                      on: { error: _vm.onAvatarError },
                    }),
                    _c("div", { staticClass: "comment-body" }, [
                      _c(
                        "div",
                        { staticClass: "comment-meta" },
                        [
                          _c("span", { staticClass: "comment-name" }, [
                            _vm._v(_vm._s(c.commenterName || "匿名")),
                          ]),
                          _c("span", { staticClass: "comment-date" }, [
                            _vm._v(_vm._s(_vm.formatDate(c.buildDate))),
                          ]),
                          c.canDelete
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "comment-del",
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDeleteComment(c)
                                    },
                                  },
                                },
                                [_vm._v(" 刪除 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "comment-text" }, [
                        _vm._v(_vm._s(c.content)),
                      ]),
                    ]),
                  ])
                }),
              ],
              2
            ),
          ]
        : !_vm.loading
        ? _c("el-empty", { attrs: { description: "找不到文章或已被移除" } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }